import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];

  select(event) {
    const selected = event.currentTarget.value;
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== selected;
    });
  }
}
